<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<section class="cart-section">
    <div class="container">
        <div class="cart-head text-center">
            <h1 class="text-capitalize">My Cart</h1>
            <!-- <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit</span>       -->
        </div>
        <div class="cart-wrapper d-flex justify-content-between flex-wrap">
          <div class="cart-details" *ngIf="!cartdata || cartdata === undefined || cartdata.length < 1">
            <div class="inner-cart d-flex justify-content-between flex-wrap">
              <div class="cart-activity clearfix">
                <div class="content-activity"><h2>Your Cart is Empty</h2>
                </div>
              </div>
            </div>
          </div>
            <div class="cart-details" *ngIf="cartdata && cartdata.length > 0">
<!--                <div class="inner-cart d-flex justify-content-between flex-wrap">-->
<!--                    <div class="cart-activity clearfix">-->
<!--                        <figure class="cart-image">-->
<!--                            <img src="assets/images/yoga.jpg" alt="yoga">-->
<!--                        </figure>-->
<!--                        <div class="content-activity space-more">-->
<!--                            <h2>Wellbeing Month- 1 Minute Meditations</h2>-->
<!--                            <span class="d-flex profile-small"><img src="assets/images/activity-images.png" alt="activity images"><span>by Ayesha Billimoria</span></span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <ul class="d-flex justify-content-between cart-observe align-items-center align-items-md-end   flex-wrap">-->
<!--                            <li class="cart-specification d-flex align-items-center flex-wrap justify-content-md-center">-->
<!--                                <i class="icon-mic"></i>-->
<!--                                <span class="text-capitalize">Recorded Classes</span>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <strong>$100.00</strong>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <a href="#">-->
<!--                                    <i class="icon-cross"></i>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                    </ul>-->
<!--                </div>-->
                <!-- NOT LOGGED IN USER SECTION -->
                <div *ngIf="cartdata && !logstatus">
                  <div class="inner-cart d-flex justify-content-between flex-wrap" *ngFor="let cartdat of cartdata">
                      <div class="cart-activity clearfix">
                          <figure class="cart-image" *ngIf="cartdat.image">
                            <img *ngIf="!urlvideo(cartdat.image)" [src]="imagelink + cartdat.image.path + cartdat.image.name" [alt]="cartdat.image.name">
                            <img *ngIf="urlvideo(cartdat.image)" [src]="cartdat.image" [alt]="cartdat.image">
                          </figure>
                          <div class="content-activity">
                              <h2>
                                {{ cartdat.programName }}
                                <!-- {{ cartdat?.programName | slice:0:150 }} {{ cartdat?.programName?.length > 150 ? '...': ''}} -->
                              </h2>
                              <p *ngIf="cartdat?.type !== 'travel' && cartdat?.productInfo?.bookingStartDate">
                                <span>{{cartdat?.productInfo?.bookingStartDate}}</span>  
                              </p>
                          </div>
                          <p *ngIf="cartdat?.type === 'shop'">
                            <span>
                              {{ cartdat?.attr?.weight }} {{ cartdat?.attr?.weight ? ' gms' : ''}}
                              {{ cartdat?.attr?.size && cartdat?.attr?.weight ? " | ": "" }}
                              {{ cartdat?.attr?.size }}
                              {{ cartdat?.attr?.weight && (cartdat?.attr?.size  || cartdat?.attr?.color )  ? " | ": "" }}
                              {{ cartdat?.attr?.color }}
                              {{ (cartdat?.attr?.weight || cartdat?.attr?.size || cartdat?.attr?.color) &&  cartdat?.attr?.flavour ? " | ": "" }}
                              {{cartdat?.attr?.flavour }}
                            </span>
                            <span *ngIf="cartdat?.quantity">
                              Qty: {{ cartdat?.quantity }}
                            </span>
                            <span *ngIf="!shippingInsideUsaFlag" class="fontSize10" [style.color]="( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 ) ? '': 'red'">
                              Shipping 
                              {{ ( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== "" && cartdat?.attr?.shippingOutUSA >=0 ) ? "available !!" : "not available on selected country." }}
                              <span *ngIf="( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >= 0 )">
                                ( {{ cartdat?.attr?.shippingOutUSA | currency:'USD':'symbol':'1.2-2' }}  )
                              </span>
                            </span>
                            <span *ngIf="shippingInsideUsaFlag" class="fontSize10" [style.color]="( cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 ) ? '': 'red'"> 
                              Shipping 
                              {{ ( cartdat?.attr?.shippingOutUSA !== "" && cartdat?.attr?.shippingInUSA >=0 ) ? "available !!" : "not available on selected country." }}
                              <span *ngIf="( cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >= 0 )">
                                (  {{ cartdat?.attr?.shippingInUSA | currency:'USD':'symbol':'1.2-2'  }} )
                              </span>
                            </span>
                          </p>
                          <p *ngIf="cartdat.portal === 'travel'">
                              <span>{{cartdat.accommodation}}</span>
                              <span>{{cartdat.date}}</span>
                              <!-- <span>{{cartdat.payStatus === 'fullamount'? 'Full': 'Deposit'}}</span> -->
                          </p>
                          
                          <p *ngIf="cartdat.portal !== 'travel'">
                            <ng-container *ngFor="let instructor of cartdat.instructor">
                            <span class="d-flex profile-small prof-icon">
                              <span class="prof-icn">
                                <img [src]="imagelink+instructor['image']['path']+instructor['image']['name']" alt="activity images">
                              </span>
                              <span class="prof-name">
                                by {{instructor.firstName}}
                              </span>
                            </span>
                          </ng-container>
                          </p>
                          <!-- <p *ngIf="cartdat.type === 'digital-programs'">
                            <ng-container *ngFor="let instructor of cartdat.instructors">
                            <span class="d-flex profile-small prof-icon"><span class="prof-icn"><img [src]="imagelink+instructor['image']['path']+instructor['image']['name']" alt="activity images"></span><span class="prof-name">by {{instructor.firstName}}{{instructor.lastName}}</span></span>
                          </ng-container>
                          </p> -->
                          <!-- <p *ngIf="cartdat.portal === 'digital-program'">
                            <ng-container *ngFor="let instructors of cartdat.instructors">
                            <span class="d-flex profile-small prof-icon"><span class="prof-icn"><img [src]="imagelink+instructor['image']['path']+instructor['image']['name']" alt="activity images"></span><span class="prof-name">by {{instructor.firstName}}{{instructor.lastName}}</span></span>
                            </ng-container>
                          </p> -->
                      </div>
                      <ul class="d-flex justify-content-between cart-observe align-items-center  flex-wrap">
                              <li class="cart-specification d-flex align-items-center flex-wrap justify-content-md-center">
                                <i class="icon-plane" *ngIf="cartdat.portal === 'travel'"></i>
                                <span class="text-capitalize" *ngIf="cartdat.portal === 'travel'">{{cartdat.categoryName}}</span>
                                <!-- <i class="icon-mic" *ngIf="cartdat.portal !== 'travel'"></i> -->
                                <span class="text-capitalize" *ngIf="cartdat.portal !== 'travel'" >{{cartdat.categoryName}}</span>

                                  <!-- <span class="text-capitalize">{{cartdat.categoryName}}</span> -->
  <!--                                <a href="#" class="trip-update">Update Trip</a>-->
                              </li>
                              <li>
                                  <strong>
                                    {{cartdat.payPrice - cartdat.totalAddonsValue | currency:'USD':'symbol':'1.2-2'}}
                                  </strong>
                              </li>
                              <li>
                                <a href="javascript:void(0)" (click)="deletecartitemlocal(cartdat.programId)">
                                  <i class="icon-cross"></i>
                                </a>
                              </li>
                      </ul>
                  </div>
                </div>
<!--                <div class="inner-cart d-flex justify-content-between flex-wrap">-->
<!--                    <div class="cart-activity clearfix">-->
<!--                        <figure class="cart-image">-->
<!--                            <img src="assets/images/yoga-grp.jpg" alt="yoga">-->
<!--                        </figure>-->
<!--                        <div class="content-activity more-space">-->
<!--                            <h2>Wellbeing Storytime LIVE</h2>-->
<!--                            <span class="d-flex profile-small"><img src="assets/images/activity-images.png" alt="activity images"><span>by lhahoi</span></span>-->
<!--                        </div>-->
<!--                        <p>July 21,2020 - July 28, 2020</p>-->
<!--                    </div>-->
<!--                    <ul class="d-flex justify-content-between cart-observe align-items-center  flex-wrap align-items-md-end">-->
<!--                            <li class="cart-specification justify-content-md-center d-flex align-items-center flex-wrap">-->
<!--                                <i class="icon-cam"></i>-->
<!--                                <span class="text-capitalize"><span class="highlighted"> Live</span> Class</span>-->
<!--                                -->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <strong>$7000.00</strong>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                                <a href="#">-->
<!--                                    <i class="icon-cross"></i>-->
<!--                                </a>-->
<!--                            </li>-->
<!--                    </ul>-->
<!--                </div>-->
              <div *ngIf="logstatus && cartdata">
                <div class="inner-cart d-flex justify-content-between flex-wrap" *ngFor="let cartdat of cartdata">
                  <div class="cart-activity clearfix">
                    <figure class="cart-image" *ngIf="cartdat?.defaultImage">
                      <!-- <img [src]="imagelink + cartdat.defaultImage.path + cartdat.defaultImage.name" [alt]="cartdat.defaultImage.name"> -->
                      <img *ngIf="!urlvideo(cartdat?.defaultImage)" [src]="imagelink + cartdat?.defaultImage?.path + cartdat?.defaultImage?.name" [alt]="cartdat?.defaultImage?.name">
                      <img *ngIf="urlvideo(cartdat?.defaultImage)" [src]="cartdat?.defaultImage" [alt]="cartdat?.defaultImage">
                    </figure>
                    <div class="content-activity">
                      <h2 data-toggle="tooltip" [title]="cartdat?.name" (click)="clickOnNameRoute(cartdat)" class="cursorHand">
                        {{ cartdat?.name | slice:0:150 }}
                        {{ cartdat?.name?.length > 150 ? '...': ''}}
                      </h2>
                      <p *ngIf="cartdat?.type !== 'travel' && cartdat?.productInfo?.bookingStartDate">
                        <span>{{cartdat?.productInfo?.bookingStartDate | date:'medium'}}</span>  
                      </p>
                    </div>
                    <p *ngIf="cartdat?.type === 'shop'">
                      
                      <span>
                        {{cartdat?.attr?.weight}} {{ cartdat?.attr?.weight ? ' gms' : ''}}
                        {{cartdat?.attr?.size && cartdat?.attr?.weight ? " | ": "" }}
                        {{cartdat?.attr?.size}}
                        {{ cartdat?.attr?.weight && (cartdat?.attr?.size  && cartdat?.attr?.color)  ? " | ": "" }}
                        {{cartdat?.attr?.color }}
                        {{ (cartdat?.attr?.weight || cartdat?.attr?.size || cartdat?.attr?.color) &&  cartdat?.attr?.flavour ? " | ": "" }}
                        {{cartdat?.attr?.flavour }}
                      </span>
                      <span *ngIf="cartdat?.itineraryData?.quantity">
                        Qty: {{cartdat?.itineraryData?.quantity }}
                      </span>
                      <span *ngIf="!shippingInsideUsaFlag" class="fontSize10" [style.color]="( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 ) ? '': 'red'">
                        Shipping 
                        {{ ( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 ) ? "available !!" : "not available on selected country." }}
                        <span *ngIf="( cartdat?.attr?.shippingOutUSA !== null && cartdat?.attr?.shippingOutUSA !== '' && cartdat?.attr?.shippingOutUSA >=0 )">
                          ( {{ cartdat?.attr?.shippingOutUSA | currency:'USD':'symbol':'1.2-2' }}  )
                        </span>
                      </span>
                      <span *ngIf="shippingInsideUsaFlag" class="fontSize10" [style.color]="( cartdat?.attr?.shippingInUSA !== null &&  cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 ) ? '': 'red'"> 
                        Shipping 
                        {{ ( cartdat?.attr?.shippingInUSA !== null && cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 )  ? "available !!" : "not available on selected country." }}
                        <span *ngIf="( cartdat?.attr?.shippingInUSA !== null &&  cartdat?.attr?.shippingInUSA !== '' && cartdat?.attr?.shippingInUSA >=0 )">
                          (  {{ cartdat?.attr?.shippingInUSA | currency:'USD':'symbol':'1.2-2'  }} )
                        </span>
                      </span>
                    </p>
                    <p *ngIf="cartdat?.type === 'travel'">
                      <span>{{cartdat?.itineraryData?.accommodation}}</span>
                      <span>{{cartdat?.itineraryData?.date}}</span>
                      <span>{{cartdat?.pay === 'fullamount'? 'Full': 'Deposit'}}</span>
                    </p>
                    <p *ngIf="cartdat?.type !== 'travel'">
                      <ng-container *ngFor="let instructor of cartdat.instructors">
                      <span class="d-flex profile-small prof-icon">
                        <span class="prof-icn">
                          <img [src]="imagelink+instructor['image']['path']+instructor['image']['name']" alt="activity images">
                        </span>
                        <span class="prof-name">by {{instructor.firstName}}</span></span>
                    </ng-container>
                    </p>
                  </div>
                  <ul class="d-flex justify-content-between cart-observe align-items-center  flex-wrap">
                    <li class="cart-specification d-flex align-items-center flex-wrap justify-content-md-center">
                      <i class="icon-plane" *ngIf="cartdat?.itineraryData?.type === 'travel'"></i>
                      <!-- <i class="icon-mic" *ngIf="cartdat?.itineraryData?.type !== 'travel'"></i> -->
                      <span class="text-capitalize">{{cartdat?.itineraryData?.categoryName}}</span>
                      
                      <!-- <span class="text-capitalize">{{cartdat.itineraryData.categoryName}}</span> -->
                      <!--                                <a href="#" class="trip-update">Update Trip</a>-->
                    </li>
                    <li>
                      <strong>{{cartdat?.itineraryData?.totalPayPrice | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </li>
                    <li>
                      <a (click)="deletecartitemlive(cartdat?.cartId)" class="cursorHand">
                        <i class="icon-cross"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              
              
            </div>
            
            <div class="cart-checkout">
                <div class="final-checkout">
                <h2 class="text-capitalize">Price Details</h2>
                <ul class="total-summary">
                    <li class="d-flex justify-content-between align-items-center">
                        <span>Subtotal</span>
                        <strong *ngIf="cartdata && !logstatus">{{ (!cartdata || cartdata === undefined || cartdata.length < 1) ? '$0': (subtotal | currency:'USD':'symbol':'1.2-2')}}</strong>
                        <strong *ngIf="logstatus && cartdata">{{subtotal | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </li>
                    <li class="d-flex justify-content-between align-items-center" *ngIf="cartdata && traveladdons > 0">
                      <span>Addons</span>
                      <strong>{{traveladdons | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </li>
                    <!-- SHIPPING CHARGE START -->
                    <li class="d-flex justify-content-between align-items-center" *ngIf="shippingCharge > 0 && checkoutButtonFlag">
                      <span>Shipping Charge</span>
                      <strong>{{shippingCharge | currency:'USD':'symbol':'1.2-2'}}</strong>
                    </li>
                    <!-- SHIPPING CHARGE END -->
                    <li class="total-info d-flex justify-content-between align-items-center">
                        <strong>Order Total</strong>
                        <strong class="final-price">
                          {{ (!cartdata || cartdata === undefined || cartdata.length < 1) ? '$0': ( totalamount + shippingCharge | currency:'USD':'symbol':'1.2-2' ) }}
                        </strong>
                    </li>
                </ul>
            </div>
            </div>
        </div>
        <div class="cart-wrapper d-flex justify-content-between flex-wrap" *ngIf="cartdata?.length > 0 ">
          <div  class="cart-details textCenterOnMobile" >
            <button  class="checkout-btn" *ngIf="cartdata.length > 0" (click)="routeToCheckout()" [disabled]="( cartdata?.length > 0 && checkoutButtonFlag && shopProductIncludeInCartData &&  !(CountrySelected?.length > 0) ) ? 'true' : ''" 
              [class]="( (cartdata?.length > 0 && checkoutButtonFlag &&  !(CountrySelected?.length > 0)) && hoverOnContinueCheckout == true ) ? 'notShowColorOnHover' : 'checkout-btn' "
              [style.cursor]=" ( (cartdata?.length > 0 && checkoutButtonFlag && shopProductIncludeInCartData && !(CountrySelected?.length > 0) ) && hoverOnContinueCheckout == true ) ? 'not-allowed': '' ">
              <span  (mouseover)="hoverOnContinueCheckout = true" (mouseleave)="hoverOnContinueCheckout = false" (mouseout)="hoverOnContinueCheckout = false">
                Continue Checkout
                <i class="icon-arrow"></i>
              </span>
            </button>
            <a *ngIf="cartdata.length > 0 && !checkoutButtonFlag" class="paddingOne floatRight floatRightNoneOnMobile">
              <span style="color: red;">
                Shipping not available on selected country.
              </span>
            </a>
            <a *ngIf="cartdata.length > 0 && shopProductIncludeInCartData && !CountrySelected" class="paddingOne floatRight floatRightNoneOnMobile">
              <span style="color: red;">
                Please select a country from below !!
              </span>
            </a>
          </div>
        </div>
        <div class="cart-wrapper d-flex justify-content-between flex-wrap" *ngIf="shopProductIncludeInCartData">
          
          <div class="cart-details" *ngIf="cartdata && cartdata.length > 0 ">
            <div class="inner-cart d-flex justify-content-between flex-wrap">
              <h6>
                Calculate shipping:
              </h6>
              <div class="input-grp d-flex justify-content-between flex-wrap">
                <div class="inputfield-wrap">
                  <label for="CountryInHomeComponent">
                    Country 
                  </label>
                  <select [(ngModel)]="CountrySelected" id="CountryInHomeComponent" (change)="countrySelectedChange($event)">
                    <option *ngFor="let i of countryList" [value]="i['name']">
                      {{ i['name'] }}
                    </option>
                  </select>
                  <div *ngIf="CountrySelected?.length > 100" class="invalid-feedback">
                    <div *ngIf="CountrySelected?.length > 100">
                      Please select country
                    </div>
                  </div>
                </div>
              </div>
            </div>

        </div>
        </div>
    </div>
</section>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>
<div class="signin-popup trip-popup" style="display: none">
  <div class="signin-wrap" id="signin-wrap">
    <a href="#" class="close-btn"><i class="icon-closed"></i></a>
    <div class="update-tripinfo d-flex justify-content-between flex-wrap">
      <div class="location-modify">
        <strong>7 Day New Year New You Reiki 1 & 2
          Training & Yoga Holiday, Bali</strong>
        <span><i class="icon-loc"></i>Bali,indonesia</span>
        <form>
          <ul class="trip-fields">
            <li class="d-flex justify-content-between flex-wrap align-items-center">
              <span>Date:</span>
              <strong>Dec 27th, 2020 - Jan 2nd, 2021 <i class="icon-dated"></i></strong>
            </li>
            <li class="d-flex justify-content-between flex-wrap align-items-center">
              <span>Accommodation:</span>
              <div class="select-wrap">
                <select>
                  <option>
                    Select Accommodation
                  </option>
                </select>
              </div>
            </li>
            <li class="d-flex justify-content-between flex-wrap align-items-center">
              <span>Number of people:</span>
              <div class="select-wrap">
                <select class="select-quant">
                  <option>
                    1
                  </option>
                </select>
              </div>
            </li>
            <li class="d-flex justify-content-between flex-wrap align-items-center">
              <span>Cancellation Policy:</span>
              <strong class="purple-msg">Moderate</strong>
            </li>
            <li class="d-flex justify-content-between flex-wrap align-items-center">
              <span class="cancel-text">FREE Cancellation:</span>
              <strong>Before Oct 28, 2020 <i class="icon-rate"></i></strong>
            </li>
            <li class="d-flex justify-content-between flex-wrap align-items-center m-0">
              <span>Price</span>
              <strong class="trip-price">$100</strong>
            </li>
          </ul>
        </form>
      </div>
      <div class="location-image">
        <figure>
          <img src="assets/images/update-pic.jpg" alt="update">
        </figure>
        <ul class="booking-points">
          <li>No Booking Fees</li>
          <li>Best Price Guarantee</li>
          <li class="m-0">Free Cancellation Available</li>
        </ul>
      </div>
      <div class="trip-pay">
        <strong class="pay-head">Pay now</strong>
        <ul class="pay-mode">
          <li class="d-flex justify-content-between flex-wrap">
            <div class="d-flex choice-wrap justify-content-between align-items-center">
              <label>
                <input type="radio" name="radio">Deposit
                <span class="radio-check"></span>
              </label>
            </div>
            <div class="choice-wrap-data">
              <strong>$180.00</strong>
              <p>The remaining <span class="light-hover">$180.00</span> should be paid directly to the retreat owner on Nov 27th, 2020.</p>
            </div>
          </li>
          <li class="d-flex justify-content-between flex-wrap">
            <div class="d-flex choice-wrap justify-content-between align-items-center">
              <label>
                <input type="radio" name="radio">Full Price
                <span class="radio-check"></span>
              </label>
            </div>
            <div class="choice-wrap-data">
              <strong>$180.00</strong>
              <p>The remaining <span class="light-hover">$180.00</span> should be paid directly to the retreat owner on Nov 27th, 2020.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <a href="#" class="btn trip-update">Continue booking</a>
  </div>
</div>
